import { useEffect, useState } from "react"
import AgoraRegularManager from "../Agora/AgoraRegularManager"
import { AgoraManagerType, IAgoraManagerProps } from "../Agora/AgoraManager"
import { AgoraTrackType } from "../Agora/AgoraRtcCustomTypes"
import { getCameraConfig } from "../Utils/app"

interface IAdditionalRegularDeviceProps
{
    managerId: number,
    agoraCredentials: IAgoraManagerProps,
    startCommunication?: boolean,
    onError: (error: unknown, args?: string | number) => void,
    onStart?: (published: boolean, type: AgoraManagerType, managerId: number) => void,
    onStopAdditionalDevHandler?: (type: AgoraManagerType, managerId: number) => void,
    source?: MediaDeviceInfo
}

const AdditionalRegularDevice = (props: IAdditionalRegularDeviceProps) => {
    const { 
        managerId, 
        agoraCredentials: credentials, 
        onError,
        source
    } = props

    const [agoraManager, setAgoraManager] = useState<AgoraRegularManager>()
    const [startCommunication, setStartCommunication] = useState<boolean>(false)

    useEffect(() => {
        if(!agoraManager)
        {
            console.log("Add additional device")

            const am = new AgoraRegularManager(credentials)
            am.initialize(getCameraConfig()).then(() => {
                console.debug("Props", props)
                console.debug("Additional device regular manager initialized")
                setAgoraManager(am)
                setStartCommunication(true)
            })
        }

        return () => {
            if(!agoraManager) return

            if(props.onStopAdditionalDevHandler)
                props.onStopAdditionalDevHandler("regular", managerId)

            agoraManager.destroy()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agoraManager])

    useEffect(() => {
        if(!startCommunication) return
        if(!agoraManager?.tracks) return
        if(!credentials.appId) return
        if(!credentials.channel) return
        if(!credentials.token) return
        
        const init = async(name: string, mng: AgoraRegularManager) => {
            if(!credentials.appId) return
            if(!credentials.token) return
            if(!mng?.client) return undefined;
            if(!mng?.tracks) return undefined;

            const track = mng.tracks[AgoraTrackType.VIDEO];
            if(!track) throw new Error("Could not get track for Additional Regular device");

            const uid = "track_" + track.getTrackId();

            track.on("track-ended", () => {
                console.debug("Track ended >>")
                onError("TRACK_ENDED", managerId)
            })

            await mng.client.join(credentials.appId, name, credentials.token, uid);
            mng.client.publish(track).then(() => {
                if(props.onStart)
                    props.onStart(true, "regular", managerId)
            });
        }

        init(credentials.channel, agoraManager)
            .catch(err => onError(err));
    }, [agoraManager, startCommunication])
    
    useEffect(() => {
        if(!(source && typeof source === "object")) return;

        if(agoraManager?.tracks)
        {
            agoraManager?.tracks[AgoraTrackType.VIDEO]?.setDevice(source.deviceId);
        }
    }, [source, agoraManager?.tracks])

    return (null)
}

export default AdditionalRegularDevice
